export default "__VITE_ASSET__CvZ_BDrN__"